// src/components/modals/MnemonicModal.jsx
import React from 'react';
import '../../styles/components/modals.css';
import useModalHistory from '../../hooks/useModalHistory';
const MnemonicModal = ({ isOpen, mnemonic, onClose, onContinue }) => {
  useModalHistory(isOpen, onClose, 'email-verification-modal');


  if (!isOpen || !mnemonic) return null;

  const mnemonicWords = mnemonic.split(' ');
  const wordsPerColumn = Math.ceil(mnemonicWords.length / 2);

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Mnemonic Words</h5>
          <button type="button" className="close-button" onClick={onClose}>×</button>
        </div>
        <div className="modal-body">
          <div className="alert-warning">
            <strong>Important:</strong> These words are the only way to recover your account.
            Please write them down and store them in a safe place. Do not share them with anyone.
          </div>
          <div className="mnemonic-container">
            {mnemonicWords.map((word, index) => (
              <div key={index} className="mnemonic-word">
                <span className="word-number">{index + 1}.</span>
                <span className="word-text">{word}</span>
              </div>
            ))}
          </div>
        </div>
        <div className="modal-footer">
          <button type="button" className="continue-button" onClick={onContinue}>
            Continue
          </button>
        </div>
      </div>
    </div>
  );
};

export default MnemonicModal;